import React, { useEffect, useRef, useState } from 'react';
import { AutoComplete, Form, Input, Table, Tag, Typography } from 'antd';
import api from '../utils/api';

const { Text } = Typography;

const pad3 = (n) => String(n).padStart(3, '0');
const fmtDate = (d) => (d ? String(d).slice(0, 10) : '');

function UsagePanel({ song, usage }) {
  if (!usage) return null;
  const first = usage.first;
  return (
    <div className="vt-usage-panel" style={{ border: '1px solid #d6e4ff', background: '#f0f5ff', borderRadius: 8, padding: 10, marginBottom: 12 }}>
      {song && (
        <div style={{ marginBottom: 6 }}>
          <Text strong>Song Library: {song.title}</Text>{' '}
          {song.singer && <Tag>{song.singer}</Tag>}
          {song.studio && <Tag color="purple">{song.studio}</Tag>}
          {song.company_name && <Tag color="blue">{song.company_name}</Tag>}
          <Tag color={song.has_audio ? 'green' : 'red'}>{song.has_audio ? 'Audio hai' : 'Audio nahi'}</Tag>
        </div>
      )}
      <div style={{ marginBottom: 6 }}>
        {usage.count > 0 ? (
          <Text>
            Is audio ke ab tak <Text strong style={{ color: '#cf1322' }}>{usage.count}</Text> video bane
            {' '}({usage.uploaded} upload hue) → ye wala <Text strong style={{ color: '#389e0d' }}>#{pad3(usage.next)}</Text> hoga
          </Text>
        ) : (
          <Text type="success" strong>Is audio ka abhi tak koi video nahi bana — ye pehla (#001) hoga</Text>
        )}
      </div>
      {first && (
        <div style={{ marginBottom: 6 }}>
          <Text type="secondary">Pehli baar: </Text>
          {first.first_time_code && <Tag color="purple">{first.first_time_code}</Tag>}
          <Text strong>{first.channel_name || '—'}</Text>
          {first.youtube_link && <> · <a href={first.youtube_link} target="_blank" rel="noreferrer">{first.youtube_link}</a></>}
          {first.artist && <> · {first.artist}</>}
          {first.at && <Text type="secondary"> · {fmtDate(first.at)}</Text>}
        </div>
      )}
      {usage.count > 0 && (
        <Table
          size="small" rowKey="id" pagination={false} scroll={{ y: 180 }}
          dataSource={usage.uses}
          columns={[
            { title: 'Code', dataIndex: 'first_time_code', width: 80, render: v => v || '—' },
            { title: 'Title', dataIndex: 'song_title', ellipsis: true },
            { title: 'Channel', dataIndex: 'channel_name', width: 130, ellipsis: true, render: v => v || '—' },
            { title: 'Link', dataIndex: 'youtube_link', width: 70, render: v => (v ? <a href={v} target="_blank" rel="noreferrer">Open</a> : <Tag>Pending</Tag>) },
            { title: 'Date', dataIndex: 'at', width: 95, render: fmtDate },
          ]}
        />
      )}
    </div>
  );
}

export default function VtSongPicker({ form, open, label = 'Song (Song Library se search karo)' }) {
  const [songs, setSongs] = useState([]);
  const [picked, setPicked] = useState(null);
  const [typed, setTyped] = useState(null);
  const timer = useRef(null);

  useEffect(() => {
    if (open) { setSongs([]); setPicked(null); setTyped(null); }
  }, [open]);

  const search = (q) => {
    clearTimeout(timer.current);
    setPicked(null);
    if (!q || q.trim().length < 2) { setSongs([]); setTyped(null); return; }
    timer.current = setTimeout(async () => {
      try {
        const res = await api.get('/video-tracker/song-search', { params: { q: q.trim() } });
        setSongs(res.data?.songs || []);
        setTyped(res.data?.typed?.count ? res.data.typed : null);
      } catch { /* ignore */ }
    }, 300);
  };

  const onSelect = (id) => {
    const s = songs.find(x => String(x.id) === String(id));
    if (!s) return;
    setPicked(s);
    const cur = form.getFieldsValue(['singer', 'artist']);
    setTimeout(() => form.setFieldsValue({
      song_title: `${s.title} ${pad3(s.usage.next)}`,
      song_id: s.id,
      singer: cur.singer || s.singer || undefined,
      artist: cur.artist || s.artist || undefined,
    }), 0);
  };

  const options = songs.map(s => ({
    value: String(s.id),
    label: (
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {s.title}{s.singer ? <Text type="secondary"> · {s.singer}</Text> : null}
        </span>
        <Tag color={s.usage.count ? 'orange' : 'green'}>{s.usage.count ? `${s.usage.count} video` : 'Naya'}</Tag>
      </div>
    ),
  }));

  return (
    <>
      <Form.Item name="song_title" label={label} rules={[{ required: true, message: 'Song title required' }]}
        extra="Gaane ka naam likho — Song Library se list aayegi, chuno to agla number (jaise 011) khud lag jayega">
        <AutoComplete options={options} onSearch={search} onSelect={onSelect} placeholder="e.g. Kabutar Bole Gutar Gu" />
      </Form.Item>
      <Form.Item name="song_id" hidden><Input /></Form.Item>
      <UsagePanel song={picked} usage={picked ? picked.usage : typed} />
    </>
  );
}
